"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StormDocumentHistoryType = void 0;
var StormDocumentHistoryType;
(function (StormDocumentHistoryType) {
    StormDocumentHistoryType["CREATED"] = "CREATED";
    StormDocumentHistoryType["ASSESSOR_CHANGE"] = "ASSESSOR_CHANGE";
    StormDocumentHistoryType["STATUS_CHANGE"] = "STATUS_CHANGE";
    StormDocumentHistoryType["REVIEWED"] = "REVIEWED";
})(StormDocumentHistoryType = exports.StormDocumentHistoryType || (exports.StormDocumentHistoryType = {}));
//# sourceMappingURL=stormDocumentHistoryType.js.map